import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExpressRoutingModule } from './express-routing.module';
import { ExpressComponent } from './express.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ExpressListComponent } from './express-list/express-list.component';
import { ExpressDetailsComponent } from './express-details/express-details.component';
import { ExpressRequestComponent } from './express-request/express-request.component';


@NgModule({
  declarations: [
    ExpressComponent,
    ExpressListComponent,
    ExpressDetailsComponent,
    ExpressRequestComponent
  ],
  imports: [
    CommonModule,
    ExpressRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    InfiniteScrollModule
  ],
  exports: [
    ExpressListComponent,
    ExpressRequestComponent
  ]
})
export class ExpressModule { }
